<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center col-10 col-sm-8 col-md-6 col-lg-4 col-xl-3">
        <p class="title primary--text">Reset Password</p>
        <div class="grey lighten-5">
          <div class="pa-5">
            <AAlert :alert="alert"></AAlert>
            <v-form ref="refForm" @submit.prevent="submit">
              <div class="pt-2 pb-2">
                <v-text-field
                  v-model="form.newPassword"
                  :rules="rules"
                  label="New Password"
                  type="password"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="form.newPasswordVerification"
                  :rules="rules"
                  label="Re-enter New Password"
                  type="password"
                  outlined
                ></v-text-field>
                <v-btn
                  color="primary"
                  type="submit"
                  :loading="loading"
                  :disabled="loading || disabled"
                >change</v-btn>
              </div>
              <div class="pa-2">
                <v-btn text @click="$router.push('/recovery')" color="primary">Send a new reset link</v-btn>
                <v-btn text>OR</v-btn>
                <v-btn text @click="$router.push('/signin')" color="primary">SIGNIN</v-btn>
              </div>
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { setTimeout } from "timers";
import snackbar from "../mixins/snackbar";
import AAlert from "../components/AAlert";
import authApi from "../api/auth";
import axios from "../api/axios";

export default {
  components: {
    AAlert
  },
  data() {
    return {
      loading: false,
      disabled: false,
      form: {
        newPassword: "",
        newPasswordVerification: ""
      },
      rules: [
        v => !!v || "Field Empty",
        v => (v && v.length >= 6) || "Name must be atleast 5 characters"
      ],
      alert: {}
    };
  },
  methods: {
    submit() {
      this.alert = {};
      if (this.$refs.refForm.validate() && this.moreValidation()) {
        this.loading = true;
        axios.post("/auth/reset-password", this.params()).then(r => {
          this.loading = false;
          this.alert = r.data;
          if (r.data.ok) this.disabled = true;
        });
      }
    },
    moreValidation() {
      if (this.form.newPassword != this.form.newPasswordVerification) {
        this.alert = {
          ok: false,
          error: "The passwords entered should match"
        };
        return false;
      }
      return true;
    },
    params() {
      return {
        token: this.$route.query.token || "",
        password: this.form.newPassword
      };
    }
  }
};
</script>

<style scoped>
.root {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.card {
  padding: 10px;
  width: 500px;
  background-color: white;
  color: #555555;
}
</style>
